var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserOutlined24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0196 13.3628L12.0281 13.3629L12.0365 13.3627L12.088 13.3615C13.7987 13.3622 15.0991 13.683 15.9884 14.2427C16.8574 14.7895 17.3624 15.5803 17.4811 16.622C17.4812 16.6235 17.4813 16.6257 17.4815 16.6287L17.4829 16.6574C17.484 16.6833 17.4851 16.7197 17.4864 16.7715C17.4889 16.875 17.4917 17.0321 17.4956 17.2737C17.496 17.3035 17.4934 17.4098 17.4629 17.5233C17.4312 17.6415 17.3853 17.7097 17.3428 17.7417C15.8165 18.8883 13.932 19.5 11.8845 19.5H11.8829C9.7959 19.5 8.24373 18.9158 6.70665 17.7438C6.64254 17.6949 6.58771 17.6003 6.55309 17.4679C6.53724 17.4073 6.5291 17.3515 6.52508 17.3116C6.52311 17.292 6.52224 17.2772 6.52186 17.2689L6.52161 17.2622L6.52161 17.2618L6.5216 17.2612L6.5216 17.2612L6.5216 17.2611L6.5216 17.2608L6.52159 17.2594L6.52154 17.2541L6.52137 17.2339L6.52079 17.161C6.52034 17.1004 6.5198 17.0193 6.51944 16.9365C6.51908 16.8536 6.51891 16.7702 6.51917 16.7047C6.5193 16.6718 6.51953 16.645 6.51987 16.6257C6.51996 16.6204 6.52006 16.6163 6.52014 16.6133C6.64036 15.5758 7.1449 14.7879 8.01139 14.2426C8.90105 13.6827 10.2023 13.3619 11.9145 13.3615L12.0196 13.3628ZM12.1295 11.2576C10.7595 11.2576 9.44222 9.76189 9.44222 7.64309C9.44222 6.67113 9.7385 5.88353 10.2084 5.34639C10.6741 4.81411 11.3329 4.5 12.1295 4.5C12.9262 4.5 13.585 4.81412 14.0508 5.3464C14.5207 5.88354 14.817 6.67113 14.817 7.64309C14.817 9.76187 13.4998 11.2576 12.1295 11.2576Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlined24);
export default __webpack_public_path__ + "static/media/userOutlined24.6e9895b0.svg";
export { ForwardRef as ReactComponent };